import moment from "moment";
const defaultRender = (value) => (value  ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        // sorter: (a, b) => a.name - b.name,
    },
    
    {
        title: 'Account Type',
        dataIndex: 'accountType',
        // sorter: (a, b) => a.accountType - b.accountType,
    },
    {
        title: 'Account Number',
        dataIndex: 'terminalLoginId',
        // sorter: (a, b) => a.terminalLoginId - b.terminalLoginId,
    },
    {
        title: 'Leverage',
        dataIndex: 'leverage',
        // sorter: (a, b) => a.leverage - b.leverage,
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        // sorter: (a, b) => a.balance - b.balance,
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
    },
    {
        title: 'Request Time',
        dataIndex: 'createdDate',
        render: defaultRender,
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    
    // {
    //     title: 'Actions',
    //     dataIndex: 'actions',
    // }

];

export default columns;